function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_10984_1865)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13 22.75C18.3848 22.75 22.75 18.3848 22.75 13C22.75 7.61522 18.3848 3.25 13 3.25C7.61522 3.25 3.25 7.61522 3.25 13C3.25 18.3848 7.61522 22.75 13 22.75Z",
  stroke: "#A5ADAF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1875 12.1875C12.403 12.1875 12.6097 12.2731 12.762 12.4255C12.9144 12.5778 13 12.7845 13 13V17.0625C13 17.278 13.0856 17.4847 13.238 17.637C13.3903 17.7894 13.597 17.875 13.8125 17.875",
  stroke: "#A5ADAF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5938 8.3623C12.6869 8.3623 12.7627 8.43805 12.7627 8.53125C12.7627 8.62445 12.6869 8.7002 12.5938 8.7002C12.5006 8.7002 12.4248 8.62445 12.4248 8.53125C12.4248 8.43805 12.5006 8.3623 12.5938 8.3623Z",
  fill: "#A5ADAF",
  stroke: "#A5ADAF",
  strokeWidth: 2.1
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_10984_1865"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 26,
  fill: "white"
})));
function SvgDisclosures(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclosures);
export default __webpack_public_path__ + "static/media/disclosures.c2def6ae.svg";
export { ForwardRef as ReactComponent };